import { ReflectionPanel } from "../models/reflection-panel.models";

export const isReflectionEmpty = (reflection: ReflectionPanel): boolean => {
  const areAnyAnswersFilled = reflection?.questions?.some((question) => (question.answer && question.answer !== "-" && question.answer !== "1.") || question?.gif?.id);
  const areAnyNotesFilled = reflection?.notes?.some((note) => (note.text && note.text !== "-" && note.text !== "1.") || note?.gif?.id);
  return !areAnyAnswersFilled && !areAnyNotesFilled;
};
